let holders = 0;
let overflowBeforeLock = "";

/**
 * Hides the document's overflow until every holder has released it. Overlays that lock scroll mount and unmount in
 * any order, so each one saving and restoring the raw style would let the last to clean up write back another's lock.
 */
export const lockDocumentScroll = (): (() => void) => {
  const root = document.documentElement;
  if (holders === 0) overflowBeforeLock = root.style.overflow;
  holders += 1;
  root.style.overflow = "hidden";
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) root.style.overflow = overflowBeforeLock;
  };
};
